export default __webpack_public_path__ + "static/media/search.a8be643c.svg";